module.exports = __webpack_public_path__ + "img/8a7690e27b942e2a51a6ebdda31bae81.jpg";